// extracted by mini-css-extract-plugin
var _1 = "RequestTableRow-moduleRequestTableRow__EmLpe TableComponent-modulerow__xPAo4";
var _2 = "RequestTableRow-modulearchived__coXhV";
var _3 = "RequestTableRow-modulearchivedIconContainer___NNox EntityArchivedIcon-moduleentityArchivedIconContainer__u1fL2 IconNG-moduleiconContainer__SxWZ0";
export { _1 as "RequestTableRow", _2 as "archived", _3 as "archivedIconContainer" }
